var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { MiniQuestion } from '../../../question/miniquestion/MiniQuestion';
export class MicroToMiniQuestion {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get topic() {
        return this.parent.topic;
    }
    get microQuestions() {
        return this.parent.microQuestions;
    }
    get miniQuestions() {
        return this.miniQuestionsFromMicroQuestions(this.microQuestions);
    }
    miniById = new Map();
    miniQuestionsFromMicroQuestions(microQuestions) {
        return microQuestions.map((micro) => {
            if (this.miniById.has(micro.id)) {
                return this.miniById.get(micro.id);
            }
            const mini = new MiniQuestion(micro.id, this);
            this.miniById.set(micro.id, mini);
            return mini;
        });
    }
}
__decorate([
    computed
], MicroToMiniQuestion.prototype, "miniQuestions", null);
